import { AllieSkeleton, MulticolorProgressBar } from '../../../components';
import { AlliePerformanceBarsProps } from './PerformanceBars.types';
import {
  PeformanceSummaryStyled,
  PerformanceBarStyled,
  PerformanceBarsContainerStyled,
  PerformanceBarsStyled,
} from './PerformanceBars.styles';

const BAR_HEIGHT = 59.25;

export const AlliePerformanceBars: React.FC<AlliePerformanceBarsProps> = ({
  summary,
  backgroundColor = 'neutral',
  width,
  bars,
  loading,
  classNames,
}) => (
  <PerformanceBarsStyled className={classNames?.container}>
    {loading ? (
      <AllieSkeleton animated style={{ width: 160, height: BAR_HEIGHT, marginRight: 10 }} />
    ) : (
      <PeformanceSummaryStyled
        slot="start"
        backgroundColor={backgroundColor}
        className={classNames?.summary}
      >
        {summary}
      </PeformanceSummaryStyled>
    )}
    <PerformanceBarsContainerStyled className={classNames?.bar} width={width}>
      {loading && <AllieSkeleton animated style={{ width: '100%', height: BAR_HEIGHT }} />}
      {!loading && bars.map((bar) => (
        <PerformanceBarStyled>
          <MulticolorProgressBar values={bar} height="auto" borderRadius={100} />
        </PerformanceBarStyled>
      ))}
    </PerformanceBarsContainerStyled>
  </PerformanceBarsStyled>
);
